<div
  class="layout-container"
  [ngClass]="{
    'full-layout': !this.collapsedSidebar,
    'shrinked-layout': this.collapsedSidebar
  }"
>
  <div class="side-content mobile-hidden">
    <app-sidebar (toggleContainer)="toggleLayout($event)"></app-sidebar>
  </div>
  <div class="side-content mobile-vissible" *ngIf="this.openShowMenu == true" >
    <app-sidebar (toggleContainer)="toggleLayout($event)" [toggleMenu]="toggleSidebar" (toggleSidebarTest)="toggleSidebar()" ></app-sidebar>
  </div>
  <div class="body-wrapper">
    <app-topbar [toggleMenu]="toggleSidebar" (toggleSidebarTest)="toggleSidebar()"></app-topbar>
    <div class="main-content">
      <ng-content></ng-content>
    </div>
  </div>
</div>